import React from 'react';
import {
    RhColumns,
    RhNumberField,
    RhSingleAutocomplete,
    RHTextField,
} from '../../../../../dum';
import { FIELD_LABELS, shortLabel } from '../../../../../../helpers';

// One row of an account's supplier resource catalog. Mirrors the product
// catalog row, but guideline-only: just a resource, a unit price and free-form
// notes — no group weight, no discontinued indicator, no price rules.
export interface IAccountResourceRow {
    id?: number | null;
    resource?: {
        id: number;
        name: string;
    } | null;
    unit_price: number;
    notes?: string;
}

export const ACCOUNT_RESOURCES = 'account_resources';

type ResourceOption = {
    id: number;
    name: string;
};

const ARRAY_NAME = ACCOUNT_RESOURCES;

const RESOURCE: keyof IAccountResourceRow = 'resource';
const UNIT_PRICE: keyof IAccountResourceRow = 'unit_price';
const NOTES: keyof IAccountResourceRow = 'notes';

const defaultValue: IAccountResourceRow = {
    resource: null,
    unit_price: 0,
    notes: '',
};

export function AccountResourcesColumns({
    resources,
}: {
    resources: ResourceOption[];
}) {
    return (
        <RhColumns
            title={'Recursos del catálogo'}
            name={ARRAY_NAME}
            defaultValue={defaultValue}
            items={[
                {
                    cellGrow: 3,
                    getField: (index) => {
                        return (
                            <RhSingleAutocomplete
                                itemText={'name'}
                                itemValue={'id'}
                                returnObject
                                options={resources}
                                name={`${ARRAY_NAME}.${index}.${RESOURCE}`}
                                label={shortLabel(FIELD_LABELS.resource_id)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    getField: (index) => {
                        return (
                            <RhNumberField
                                name={`${ARRAY_NAME}.${index}.${UNIT_PRICE}`}
                                label={shortLabel(FIELD_LABELS.unit_price)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    cellGrow: 3,
                    getField: (index) => {
                        return (
                            <RHTextField
                                name={`${ARRAY_NAME}.${index}.${NOTES}`}
                                label={shortLabel(FIELD_LABELS.notes)}
                                disableGutters
                            />
                        );
                    },
                },
            ]}
        />
    );
}
